import { adjust } from "./util"

// Module de calcul de la correction de SO3

/** point d'entrée du module */
export const so3Correction = ({ reactorVolume, reactorTemperature, sufluricAcidCH, sulfuricAcidD, slurryDensity, phosphoricAcidContent, phosphoricAcidDensity, sulfuricMesured, sulfuricExpected, duration }) => {
    try {
        const w = slurryQuantity(reactorVolume, slurryDensity)
        const s = solidsContent(slurryDensity, phosphoricAcidDensity)
        const qs = solidQuantity(w, s)
        const ql = liquidQuantity(w, qs)
        const vl = liquidVolume(ql, phosphoricAcidDensity)
        const e = so3Variation(vl, sulfuricExpected, sulfuricMesured)
        const fw = quantityVariationh2so4(e)
        const fv = h2so4Quantity(fw, sulfuricAcidD, sufluricAcidCH)
        const x = adjust( flowVariation(fv, duration), 3)
        return { flowVariation: x, duration } // On retourne la variation et le temps de correction
    } catch (err) {
        throw err
    }
}

const slurryQuantity = (v, ds) => {
    return v * ds
}

const solidsContent = (ds, dp) => {
    const x = 1 - (dp / ds)
    const y = 1 - (dp / 2320)
    return 100 * x / y
}

const solidQuantity = (w, s) => {
    return w * s / 100
}

const liquidQuantity = (w, qs) => {
    return w - qs
}

const liquidVolume = (ql, dp) => {
    return 1000 * ql / dp
}

const so3Variation = (vl, ct, cm) => {
    return vl * (ct - cm) / 1000
}

const quantityVariationh2so4 = (e1) => {
    return e1 * 98 / 80
}

const h2so4Quantity = (fw, sh, ch) => {
    return (fw * 100) / (sh * ch)
}

const flowVariation = (fv, t) => {
    return fv * 60 / t
}